import { userApi } from './index';
import { config } from '../config';

export enum DeviceType {
  Android = 1,
  IOS = 2,
  WEB = 3,
}

interface ConnectDeviceRequest {
  deviceID: string;
  deviceType?: DeviceType;
}

export const firebaseApi = userApi.injectEndpoints({
  endpoints: (build) => ({
    connectDevice: build.mutation<{ amount: number }, ConnectDeviceRequest>({
      query: ({ deviceID }) => ({
        url: config.FIREBASE.CONNECT_DEVICE,
        method: 'POST',
        body: {
          deviceID,
          deviceType: DeviceType.WEB,
        },
      }),
      invalidatesTags: ['UserInfo', 'Accounts'],
    }),
  }),
});
